import { apiClient } from './ApiClient';

export interface Contact {
  id: number;
  user_id: string;
  first_name: string;
  last_name?: string;
  email: string;
  phone?: string;
  slug: string;
  category: string;
  tags?: string[];
  created_at: string;
  updated_at: string;
}

export interface AssetContact extends Contact {
  role: string;
}

export interface CreateContactDto {
  first_name: string;
  last_name?: string;
  email: string;
  phone?: string;
  category?: string;
  tags?: string[];
}

export interface CreateAssetContactDto extends CreateContactDto {
  role?: string;
}

export const ContactService = {
  // Get all contacts
  getContacts: async (): Promise<Contact[]> => {
    const response = await apiClient.get<Contact[]>('/contacts');
    return response.data;
  },

  // Get a single contact
  getContact: async (id: number): Promise<Contact> => {
    const response = await apiClient.get<Contact>(`/contacts/${id}`);
    return response.data;
  },

  // Get contacts for an asset
  getAssetContacts: async (assetId: string): Promise<AssetContact[]> => {
    const response = await apiClient.get<AssetContact[]>(
      `/contacts/asset/${assetId}`,
    );
    return response.data;
  },

  // Create a new contact
  createContact: async (data: CreateContactDto): Promise<Contact> => {
    const response = await apiClient.post<Contact>('/contacts', data);
    return response.data;
  },

  // Create a contact for an asset
  createAssetContact: async (
    assetId: string,
    data: CreateAssetContactDto,
  ): Promise<Contact> => {
    const response = await apiClient.post<Contact>(
      `/contacts/asset/${assetId}`,
      data,
    );
    return response.data;
  },

  // Update a contact
  updateContact: async (
    id: number,
    data: Partial<CreateContactDto>,
  ): Promise<Contact> => {
    const response = await apiClient.put<Contact>(`/contacts/${id}`, data);
    return response.data;
  },

  // Delete a contact
  deleteContact: async (id: number): Promise<void> => {
    await apiClient.delete(`/contacts/${id}`);
  },
};

export default ContactService;
